module.exports = __webpack_public_path__ + "media/images/poor_star-13073ca7e94662b069bca67df5c2f782.svg";